import {Injectable, Type} from "@angular/core"

import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog"

import {LgkDialogManager} from "@logick/ui/dialog"

/**
 * Surcharge de LgkDialogManager : un dialog plein écran ouvert via openFullScreen
 * empile une entrée d'historique factice. Un retour arrière du navigateur ferme
 * alors le dialog au lieu de faire naviguer l'utilisateur vers la page précédente.
 */
@Injectable()
export class AppDialogManager extends LgkDialogManager {
  override openFullScreen<T>(componentType: Type<T>, config: DynamicDialogConfig = {}): DynamicDialogRef<any> {
    const ref = super.openFullScreen(componentType, config)

    history.pushState({lgkDialog: true}, "")
    let closingFromPopState = false

    const popStateHandler = (): void => {
      closingFromPopState = true
      ref.close()
    }
    window.addEventListener("popstate", popStateHandler)

    ref.onClose.subscribe(() => {
      window.removeEventListener("popstate", popStateHandler)
      if (!closingFromPopState) {
        history.back()
      }
    })

    return ref
  }
}
